// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__WkxhF","signatureBlock":"Footer_signatureBlock__3BE0t","signature":"Footer_signature__3nuG9"};